import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    {
        name: "परिचय ",
        link: "#",
        content: (
            <div>
                <p>
                    निखिल विश्व साहित्य और साहित्यशास्त्र, सौन्दर्यशास्त्र, कला और कलाशास्त्र,
                    संगीत और संगीतशास्त्र, नाट्य और नाटयशास्त्र आदि इसके अन्तर्गत होने के कारण लोकजीवन में यह साहित्यशास्त्र अपनी महत्त्वपूर्ण भूमिका का निर्वाह करता है...
                </p>
                <ul>
                    <li>संस्कृत भाषा को साहित्य के माध्यम से वैश्विक उच्च पद पर आसीन करना।</li>
                    <li>विभिन्न शाखाओं का विकास, अध्ययन व अध्यापन।</li>
                    <li>नाट्य एवं अभिनय के सैद्धांतिक व प्रायोगिक पक्ष को बढ़ावा देना।</li>
                    <li>भारतीय ज्ञान परंपरा का प्रचार।</li>
                </ul>
            </div>
        )
    },
    {
        name: "संचालित पाठ्यक्रम",
        link: "#",
        content: (
            <ul>
                <li>शास्त्री (साहित्य)</li>
                <li>आचार्य (साहित्य)</li>
                <li>विद्यावारिधि</li>
            </ul>
        )
    },
    {
        name: "शैक्षणिक सदस्य",
        link: "#",
        content: (
            <div className="mb-4">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover align-middle">
                        <thead className="table-primary text-center">
                            <tr>
                                <th>चित्र</th>
                                <th>आचार्य का नाम</th>
                                <th>पद</th>
                                <th>उच्चतम योग्यता</th>
                                <th>सम्पर्क</th>
                                <th>ई-मेल</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr>
                                <td style={{ width: "140px" }}>
                                    <img
                                        src={require("../assets/Photos/डॉ. जगत नारायण.JPG")}
                                        alt="डॉ. जगत नारायण"
                                        className="img-fluid rounded"
                                        style={{ height: "120px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>डॉ. जगत नारायण</td>
                                <td>विभागाध्यक्ष, सह आचार्य</td>
                                <td>Ph.D</td>
                                <td>9996041064</td>
                                <td>
                                    <a href="mailto:hodsahitya@mvsu.ac.in">hodsahitya@mvsu.ac.in</a>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <img
                                        src={require("../assets/Photos/डॉ. रामानन्द मिश्र (साहित्य विभाग).jpg")}
                                        alt="डॉ. रामानन्द मिश्र"
                                        className="img-fluid rounded"
                                        style={{ height: "120px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>डॉ. रामानन्द मिश्र</td>
                                <td>सहायक आचार्य</td>
                                <td>Ph.D, NET</td>
                                <td>7355115414</td>
                                <td>
                                    <a href="mailto:ramachd91@gmail.com">ramachd91@gmail.com</a>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <img
                                        src={require("../assets/Photos/डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन).JPG")}
                                        alt="डॉ. कृष्ण चन्द्र पाण्डे"
                                        className="img-fluid rounded"
                                        style={{ height: "120px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>डॉ. कृष्ण चन्द्र पाण्डे</td>
                                <td>सहायक आचार्य</td>
                                <td>Ph.D</td>
                                <td>9810373278</td>
                                <td>
                                    <a href="mailto:krishnapanday1967@gmail.com">krishnapanday1967@gmail.com</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    },



    {
        name: "समय सारिणी",
        link: "#",
        content: <p>समय सारिणी संबंधित जानकारी शीघ्र ही उपलब्ध कराई जाएगी।</p>
    },
    {
        name: "सुविधाएं",
        link: "#",
        content: <p>साहित्य विभाग में ग्रंथालय, शोध कक्ष व अन्य बुनियादी सुविधाएं उपलब्ध हैं।</p>
    },
    {
        name: "सेमीनार/सम्मेलन/कार्यशाला",
        link: "#",
        content: <p>विभाग द्वारा समय-समय पर शोध संगोष्ठियाँ व कार्यशालाएँ आयोजित की जाती हैं।</p>
    },
    {
        name: "शोधच्छात्र",
        link: "#",
        content: (
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>गवेषक</th>
                        <th>पर्यवेक्षक</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>पुष्पा</td><td>डॉ. जगत नारायण</td></tr>
                    <tr><td>कुलदीप कुमार</td><td>डॉ. जगत नारायण</td></tr>
                    <tr><td>नीलम</td><td>डॉ. जगत नारायण</td></tr>
                    <tr><td>अजय</td><td>डॉ. जगत नारायण</td></tr>
                    <tr><td>सोनिया</td><td>डॉ. जगत नारायण</td></tr>
                    <tr><td>श्वेता</td><td>डॉ. रामानन्द मिश्र</td></tr>
                    <tr><td>प्यारे लाल</td><td>डॉ. रामानन्द मिश्र</td></tr>
                    <tr><td>इला</td><td>डॉ. कृष्ण चन्द्र पाण्डेय</td></tr>
                    <tr><td>सुमन लता</td><td>डॉ. कृष्ण चन्द्र पाण्डेय</td></tr>
                    <tr><td>रोहित कुमार</td><td>डॉ. कृष्ण चन्द्र पाण्डेय</td></tr>
                </tbody>
            </table>
        )
    },
    {
        name: "उपलब्धियां",
        link: "#",
        content: (
            <>
                <h6>नेट परीक्षा पास छात्र</h6>
                <ul>
                    <li>डिम्पल (2020-22)</li>
                    <li>पूनम (2022-24)</li>
                    <li>रीतिका (2023-25)</li>
                </ul>
                <h6>सरकारी सेवाओं में चयन</h6>
                <ul>
                    <li>अन्जू - संस्कृत अध्यापक (DSSB)</li>
                    <li>श्वेता - पी.जी.टी (मेवात, हरियाणा)</li>
                </ul>
            </>
        )
    },
    {
        name: "सम्पर्क",
        link: "#",
        content: (
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>नाम</th>
                        <th>पद</th>
                        <th>संपर्क</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>डॉ॰ जगत नारायण</td>
                        <td>सह-आचार्य एवं विभागाध्यक्ष</td>
                        <td>99960-41064</td>
                    </tr>
                    <tr>
                        <td>डॉ॰ रामानन्द मिश्र</td>
                        <td>सहायक आचार्य</td>
                        <td>73551-15414</td>
                    </tr>
                    <tr>
                        <td>डॉ. कृष्ण चन्द्र पाण्डेय</td>
                        <td>सहायक आचार्य</td>
                        <td>98103-73278</td>
                    </tr>
                </tbody>
            </table>
        )
    },
];

export default function LiteratureDepartment() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">साहित्य विभाग</h5>
                <nav className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <a
                            href="#!"
                            key={index}
                            className={`d-block mb-1 p-2 rounded small text-decoration-none ${selectedDeptIndex === index ? 'text-white fw-bold' : 'text-dark'
                                }`}
                            style={{
                                backgroundColor: selectedDeptIndex === index ? '#77236b' : 'transparent',
                                transition: 'background-color 0.3s ease, color 0.3s ease'
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedDeptIndex(index);
                                if (window.innerWidth < 768) setShowSidebar(false);
                            }}
                        >
                            {dept.name}
                        </a>
                    ))}
                </nav>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                <h4 className="mb-3 text-center" style={{ color: '#77236b' }}>
                    {departments[selectedDeptIndex].name}
                </h4> {/* This line displays the header */}
                {departments[selectedDeptIndex].content}
            </main>
        </div>
    );
}
